import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Box, Stack, AvatarGroup, Avatar, InputAdornment, TextField,} from "@mui/material";
import { farmers, taskAssign } from "../../config/images";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getReportList } from "../../config/services";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import translations from "../../config/language";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";

function clampAvatars(avatars, maxVisible = 3) {
  const totalAvatars = avatars.length;
  const visibleAvatars = avatars.slice(0, maxVisible); // Show only 3
  const surplus = totalAvatars > maxVisible ? totalAvatars - maxVisible : 0; // Extra count

  return { avatars: visibleAvatars, surplus };
}

const ReportSubmission = ({ galleryIsOpen, setGalleryIsOpen }) => {
  const [imagesData, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState("");
  const [currentPage, setCurrentPage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('page')) || 1;
  });
  const [count, setCount] = useState(0);
  const [tasksReport, setTasksReport] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [searchText, setSearchText] = useState();
  const [debounceSearchText, setDebouncedSearchText] = useState();

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Report Submission" && module.is_editor === true
  ) ? true : false;
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    const url = new URL(window.location.href);
    url.searchParams.set('page', value);
    window.history.pushState({}, '', url);
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page')) || 1;
    setCurrentPage(page);
  }, [window.location.search]);
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const handleGalleryOpen = (items, index) => {
    setGalleryIsOpen(true);
    setImages(items);
    setImageIndex(index);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes
  const fetchTaskReport = async () => {
    const data = {
      search: debounceSearchText,
    };
    try {
      const resp = await getReportList(data, currentPage, perPage);
      if (resp.data.results.success == true) {
        setTasksReport(resp.data.results.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchTaskReport();
  }, [currentPage, perPage, debounceSearchText]);

  const navigate = useNavigate()

  const handleVisibilityClick = (id) => {
    navigate(`/report-submission/report-detail/${id}?page=${currentPage}`);
  };

  const language = process.env.REACT_APP_LANGUAGE;

  return (
    <>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}> */}
      <Box className="task-assign-box">
        <Box className="d-flex justify-content-between align-items-center">
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.reportSub}
              alt=""
              // style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
             {translations[language].reportSubmission}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="crop-table-container">
          <Table className="task-assign-table" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "5%" }}>{translations[language].srNo}</TableCell>
                <TableCell style={{ width: "10%" }}>{translations[language].date}</TableCell>
                <TableCell style={{ width: "15%" }}>{translations[language].dataCollector}</TableCell>
                <TableCell style={{ width: "20%" }}>{translations[language].taskTitle}</TableCell>
                <TableCell style={{ width: "10%" }}>{translations[language].farmersRegistered}</TableCell>
                <TableCell style={{ width: "30%" }}>{translations[language].summary}</TableCell>
                <TableCell style={{ width: "10%" }}>{translations[language].attachments}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasksReport?.length > 0 ? tasksReport.map((task, index) => {
                const { avatars, surplus } = clampAvatars(
                  task.attachment.map((photo) => photo.files),
                  3
                );
                return (
                  <TableRow key={index}>
                    <TableCell style={{ width: "5%", textAlign: "center" }}>
                      {index + 1 + (currentPage - 1) * perPage}
                    </TableCell>
                    <TableCell style={{ width: "10%" }}>
                      {dayjs(task.created_at).format("YYYY/MM/DD")}
                    </TableCell>
                    <TableCell style={{ width: "15%" }}>{task.data_collector_name}</TableCell>
                    <TableCell style={{ width: "20%" }}>{task.assigned_task_title}</TableCell>
                    <TableCell style={{ width: "10%" }}>{task.number_of_farmers}</TableCell>
                    <TableCell 
                      style={{
                        width: "30%",
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {task.summary}
                    </TableCell>
                    <TableCell style={{ width: "10%", paddingTop: "2px", paddingBottom: "2px" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <AvatarGroup sx={{ "--AvatarGroup-gap": "-16px" }}>
                          {avatars.map((photo, i) => (
                            <Avatar
                              key={i}
                              className="cursor-pointer"
                              style={{ cursor: "pointer" }}
                              sx={{ width: 35, height: 35 }}
                              onClick={() =>
                                handleGalleryOpen(
                                  task.attachment.map((photo) => photo.files),
                                  i
                                )
                              }
                            >
                              <img
                                src={photo || "/placeholder.svg"}
                                alt={`Attachment ${i + 1}`}
                                style={{
                                  width: 35,
                                  height: 35,
                                  objectFit: "cover",
                                }}
                              />
                            </Avatar>
                          ))}
                          {surplus > 0 && (
                            <Avatar
                              sx={{
                                width: 35,
                                height: 35,
                                backgroundColor: "#3C4856",
                                color: "#FFFFFF",
                                fontSize: 14,
                                fontWeight: 400,
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleGalleryOpen(
                                  task.attachment.map((photo) => photo.files),
                                  3
                                )
                              } // start from 4th index as preview
                            >
                              +{surplus}
                            </Avatar>
                          )}
                        </AvatarGroup>
                        <VisibilityIcon
                          onClick={() => handleVisibilityClick(task.id)}
                          style={{ cursor: "pointer" }}
                        />
                       
                      </div>
                    </TableCell>
                  </TableRow>
                );
              }): <TableRow>
              <TableCell colSpan={7} style={{ textAlign: "center" }}>
                <img src={farmers.noData} alt="No Data" />
              </TableCell>
            </TableRow>}
            </TableBody>
          </Table>
        </Box>
        <Box
          display="flex"
          justifyContent="end"
          alignItems="center"
          className="pagination"
        >
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Stack>
        </Box>
      </Box>
      {galleryIsOpen && (
        <ImageGallery
          images={imagesData}
          isOpen={galleryIsOpen}
          onClose={() => setGalleryIsOpen(false)}
          imageIndex={imageIndex}
        />
      )}
      {/* </Grid>
      </Grid> */}
    </>
  );
};

export default ReportSubmission;
